class FooterAccordions extends HTMLElement {
  constructor () {
    super()

    this.itemEls = this.querySelectorAll('[data-el="footer-accordions.item"]')
    this.handleClick = this.handleClick.bind(this)

    this.initialiseAccordions()
  }

  initialiseAccordions () {
    this.itemEls.forEach(itemEl => {
      const triggerEl = itemEl.querySelector(
        '[data-el="footer-accordions.trigger"]',
      )

      triggerEl.addEventListener('click', this.handleClick)
    })
  }

  handleClick (event) {
    const itemEl = event.target.closest('[data-el="footer-accordions.item"]')
    const isExpanded = itemEl.getAttribute('aria-expanded') === 'true'

    if (!isExpanded) {
      const linksEl = itemEl.querySelector('[data-el="footer-accordions.links"]')
      itemEl.style.setProperty('--Max_Height', `${linksEl.scrollHeight}px`)
    }

    itemEl.setAttribute('aria-expanded', !isExpanded)
  }
}

customElements.define('footer-accordions', FooterAccordions)
